export default __webpack_public_path__ + "kate@2x.15b97868.jpg";